import OidcProvider from './OidcProvider';
import BridgeProvider from './BridgeProvider';
import JWTProvider from './JWTProvider';
import BaseProvider from './BaseProvider';

export {
  OidcProvider,
  BridgeProvider,
  JWTProvider,
  BaseProvider,
};

export default {
  Oidc: OidcProvider,
  Bridge: BridgeProvider,
  JWT: JWTProvider,
};



// WEBPACK FOOTER //
// ./src/Auth/providers/index.js